export enum CertificateStatus {
  ALL = 'all',
  VALID = 'valid',
  EXPIRED = 'expired'
}
